import {DEFAULT_DATA_COLUMNS} from "./wlf-user-table-data-columns";
import {AccountTypeLabel} from "../../../lib/constants";
import {sprintf} from "sprintf-js";

const get_date = (metadata, prop) => {
  if (!metadata || !metadata[prop]) {
    return "---";
  }
  const [ yy, mm, dd ] = metadata[prop].split("-");
  return mm + "/" + dd + "/" + yy;
}

/**
 * month is indexed by 1-Jan, 2-Feb, etc
 */
const days_in_month = (month, year) => {
  return new Date(year, month+1, 0).getDate();
}

const dump_user_csv = (items) => {
  let csv = DEFAULT_DATA_COLUMNS.join(",") + "\n";
  items.forEach(curr => {
    const cash = (curr.acct.cash && curr.acct.cash.value) || 0.;
    const line = [
      curr.tda_account_number,
      curr.user.info.role_0_first_name + " " + curr.user.info.role_0_last_name,
      curr.email,
      AccountTypeLabel(curr.account_type),
      curr.account_state,
      sprintf("%.02f", cash),
      sprintf("%.02f", curr.acct.current_price || 0),
      sprintf("%.02f", curr.user.current_price || 0),
      sprintf("%f", curr.advisory_fee || 0),
      sprintf("%f", curr.sub_advisory_fee || 0),
      curr.monthly_advisory,
      curr.quarterly_sub_advisory,
      curr.daily_sub_advisory,
      get_date(curr.acct, 'start_date'),
      get_date(curr.acct, 'current_date'),
      get_date(curr.acct, 'end_date'),
    ];
    csv += line.join(",") + "\n";
  });

  return csv;
}

const dump_sub_advisory_billing_csv = (items) => {

  const today = new Date();
  const days = days_in_month(today.getFullYear(), today.getMonth());

  let csv = "";
  items.forEach(curr => {
    const fee = curr.sub_advisory_fee || 0;
    const isUndefinedAUM = curr.acct.current_price === undefined;
    const aum = isUndefinedAUM ? 0 : curr.acct.current_price;
    const basisPointAmt = fee * 1e-4 / 365 * days * aum;
    const dollarValueAmt = curr.sub_advisory_usd;

    const amt = curr.sub_advisory_usd_override ? dollarValueAmt : basisPointAmt;

    if (amt > 0 && !isUndefinedAUM) {
      csv += curr.tda_account_number + "," + sprintf("%f", amt) + "\n";
    }
  });

  return csv;
}

const dump_advisory_billing_csv = (items) => {

  const today = new Date();
  const days = days_in_month(today.getFullYear(), today.getMonth());

  let csv = "";
  items.forEach(curr => {
    const fee = curr.advisory_fee || 0;
    const isUndefinedAUM = curr.acct.current_price === undefined;
    const aum = isUndefinedAUM ? 0 : curr.acct.current_price;
    const basisPointAmt = fee * 1e-4 / 365 * days * aum;
    const dollarValueAmt = curr.advisory_usd;

    const amt = curr.advisory_usd_override ? dollarValueAmt : basisPointAmt;

    if (amt > 0 && !isUndefinedAUM) {
      csv += curr.tda_account_number + "," + sprintf("%f", amt) + "\n";
    }

  });

  return csv;
}

export { dump_user_csv, dump_sub_advisory_billing_csv, dump_advisory_billing_csv };
